export default __webpack_public_path__ + "static/media/sub-category-hair-beauty-tattoo-piercing.a6c10d60.jpg";